export const legalPages = {
  privacy: {
    title: "Chính sách bảo mật",
    intro:
      "BlueSkyIT tôn trọng quyền riêng tư của người dùng. Chính sách này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ thông tin khi bạn truy cập website blueskyit.vn và sử dụng ứng dụng BlueRiseHS (mã ứng dụng Android: com.bluerisehs.app).",
    sections: [
      {
        heading: "1. Thông tin được thu thập và sử dụng",
        paragraphs: [
          "Tùy theo dịch vụ và tính năng bạn sử dụng, thông tin được xử lý bao gồm:",
        ],
        bullets: [
          "Thông tin tài khoản: tên, thông tin liên hệ, mã tài khoản và hồ sơ do bạn hoặc đơn vị giáo dục cung cấp.",
          "Thông tin học tập: lớp học, lịch học, kết quả học tập, đơn xin nghỉ và phản hồi phục vụ hoạt động giáo dục.",
          "Nội dung bạn cung cấp: tin nhắn, hình ảnh, tài liệu và nội dung bạn chủ động gửi qua ứng dụng.",
          "Thông tin giao dịch: sản phẩm hoặc gói dịch vụ đã mua, mã giao dịch và trạng thái thanh toán để xác minh quyền sử dụng.",
          "Thông tin kỹ thuật: phiên bản ứng dụng, hệ điều hành, mã phục vụ gửi thông báo, báo cáo lỗi và thông tin cần thiết để vận hành dịch vụ.",
          "Thông tin truy cập website: địa chỉ IP, trình duyệt, thời gian truy cập và trang đã xem.",
        ],
      },
      {
        heading: "2. Dữ liệu vị trí — Location Data",
        paragraphs: [
          "Ứng dụng BlueRiseHS không truy cập, thu thập, lưu trữ hoặc chia sẻ vị trí GPS hay vị trí gần đúng của thiết bị. Ứng dụng không sử dụng GeoIP để suy ra vị trí địa lý từ địa chỉ IP và không theo dõi vị trí khi chạy nền.",
          "Địa chỉ IP có thể được xử lý trong quá trình kết nối và vận hành dịch vụ, nhưng không được sử dụng để xác định vị trí địa lý của người dùng ứng dụng.",
          "Địa chỉ bạn tự cung cấp trong hồ sơ hoặc địa điểm lớp học hiển thị trong ứng dụng là thông tin nghiệp vụ, không phải vị trí được tự động lấy từ thiết bị.",
        ],
      },
      {
        heading: "3. Mục đích sử dụng thông tin",
        paragraphs: ["Chúng tôi sử dụng thông tin để:"],
        bullets: [
          "Cung cấp và duy trì các tính năng của website và ứng dụng.",
          "Xác thực tài khoản, hiển thị hồ sơ và thông tin học tập.",
          "Hỗ trợ trao đổi giữa người dùng và đơn vị giáo dục.",
          "Xác minh giao dịch và cung cấp quyền sử dụng dịch vụ.",
          "Gửi thông báo liên quan đến tài khoản, học tập và dịch vụ.",
          "Xử lý yêu cầu hỗ trợ, phát hiện lỗi và cải thiện chất lượng ứng dụng.",
          "Bảo vệ hệ thống và ngăn chặn hành vi gian lận.",
        ],
      },
      {
        heading: "4. Quyền truy cập thiết bị",
        paragraphs: [
          "Ứng dụng có thể yêu cầu quyền camera, hình ảnh hoặc thông báo khi cần cho tính năng tương ứng. Nội dung bạn chọn hoặc tạo chỉ được sử dụng phục vụ thao tác và chức năng liên quan.",
          "Bạn có thể quản lý hoặc thu hồi các quyền trong phần Cài đặt của thiết bị. Việc từ chối quyền có thể khiến một số tính năng tương ứng không hoạt động.",
          "Ứng dụng không yêu cầu quyền truy cập vị trí.",
        ],
      },
      {
        heading: "5. Chia sẻ thông tin",
        paragraphs: [
          "Chúng tôi không bán thông tin cá nhân của người dùng. Thông tin có thể được cung cấp trong các trường hợp:",
        ],
        bullets: [
          "Cho người nhận khi bạn chủ động gửi tin nhắn, hình ảnh hoặc tài liệu.",
          "Cho đơn vị giáo dục và người có thẩm quyền trong phạm vi cung cấp dịch vụ, theo phân quyền.",
          "Cho nhà cung cấp dịch vụ hỗ trợ lưu trữ, thông báo, chẩn đoán lỗi, cập nhật ứng dụng và thanh toán, trong phạm vi cần thiết để thực hiện chức năng.",
          "Khi có sự đồng ý của bạn hoặc yêu cầu hợp pháp từ cơ quan có thẩm quyền.",
        ],
        afterBullets: [
          "Ứng dụng tích hợp các dịch vụ như Firebase Cloud Messaging, Sentry, PostHog, Expo và Google Play phục vụ những chức năng liên quan. Việc sử dụng các dịch vụ này phải phù hợp với phạm vi xử lý dữ liệu được mô tả trong chính sách này.",
        ],
      },
      {
        heading: "6. Lưu giữ và bảo vệ thông tin",
        paragraphs: [
          "Thông tin được lưu giữ trong thời gian cần thiết để cung cấp dịch vụ, xử lý yêu cầu của người dùng và thực hiện nghĩa vụ liên quan. Khi không còn cần thiết, dữ liệu được xóa hoặc ẩn danh, trừ trường hợp cần tiếp tục lưu giữ theo quy định pháp luật hoặc để giải quyết tranh chấp.",
          "Chúng tôi áp dụng các biện pháp kỹ thuật và quản lý phù hợp nhằm hạn chế truy cập trái phép, mất mát hoặc tiết lộ thông tin. Quyền truy cập dữ liệu được giới hạn cho các bên có nhiệm vụ liên quan.",
        ],
      },
      {
        heading: "7. Quyền của người dùng và liên hệ",
        paragraphs: [
          "Bạn có thể yêu cầu truy cập, chỉnh sửa hoặc xóa thông tin cá nhân bằng cách liên hệ lienhe@blueskyit.vn.",
          "Chúng tôi có thể yêu cầu thông tin cần thiết để xác minh chủ thể yêu cầu. Nếu một phần dữ liệu cần được tiếp tục lưu giữ, chúng tôi sẽ giải thích lý do và phạm vi lưu giữ khi xử lý yêu cầu.",
          "Đối với hồ sơ học sinh do đơn vị giáo dục quản lý, học sinh hoặc phụ huynh/người đại diện có thể liên hệ đơn vị giáo dục hoặc BlueSkyIT để được hướng dẫn xử lý.",
        ],
      },
      {
        heading: "8. Thay đổi chính sách",
        paragraphs: [
          "Chúng tôi có thể cập nhật chính sách để phản ánh thay đổi của dịch vụ và cách xử lý dữ liệu. Phiên bản mới được công bố tại trang này; các thay đổi đáng kể sẽ được thông báo qua kênh phù hợp.",
        ],
      },
    ],
    footerLines: [
      "Đơn vị: Công ty Cổ phần Đầu tư & Công nghệ Bầu Trời Xanh — BlueSkyIT",
      "Email: lienhe@blueskyit.vn",
      "Website: https://blueskyit.vn",
    ],
  },
  terms: {
    title: "Điều khoản sử dụng",
    intro:
      "Cảm ơn bạn đã truy cập website BlueSkyIT.vn. Khi sử dụng trang web này, bạn đồng ý tuân thủ các điều khoản sử dụng sau đây. Vui lòng đọc kỹ trước khi tiếp tục truy cập.",
    sections: [
      {
        heading: "1. Phạm vi điều khoản",
        paragraphs: [
          "Những điều khoản này áp dụng cho tất cả người truy cập và sử dụng trang web BlueSkyIT. Bạn cam kết rằng mình đã đủ 18 tuổi hoặc được phép theo quy định pháp luật để sử dụng trang web này.",
        ],
      },
      {
        heading: "2. Quyền sở hữu trí tuệ",
        paragraphs: [
          "Toàn bộ nội dung, hình ảnh, video, logo, và tên thương hiệu hiển thị trên website BlueSkyIT đều thuộc sở hữu của BlueSkyIT hoặc các đối tác có liên quan. Nghiêm cấm sao chép, sử dụng hoặc phân phối nội dung khi chưa có sự đồng ý bằng văn bản.",
        ],
      },
      {
        heading: "3. Sử dụng website",
        paragraphs: [
          "Bạn chỉ được phép sử dụng website vào mục đích hợp pháp. Nghiêm cấm sử dụng website cho các hoạt động bất hợp pháp, bao gồm nhưng không giới hạn, việc truyền tải nội dung có hại, gian lận, hay vi phạm quyền của bên thứ ba.",
        ],
      },
      {
        heading: "4. Tài khoản người dùng",
        paragraphs: [
          "Khi tạo tài khoản trên BlueSkyIT, bạn có trách nhiệm bảo mật thông tin đăng nhập và các hoạt động liên quan đến tài khoản của bạn. BlueSkyIT không chịu trách nhiệm cho bất kỳ tác hại nào phát sinh từ việc sử dụng tài khoản không đúng cách.",
        ],
      },
      {
        heading: "5. Chính sách bảo mật",
        paragraphs: [],
        privacyLinkParagraph: true,
      },
      {
        heading: "6. Giới hạn trách nhiệm",
        paragraphs: [
          "BlueSkyIT không chịu trách nhiệm với bất kỳ thiệt hại nào, dù trực tiếp hay gián tiếp, phát sinh từ việc sử dụng trang web. BlueSkyIT không đảm bảo website không có lỗi hoặc khả năng truy cập liên tục.",
        ],
      },
      {
        heading: "7. Thay đổi điều khoản",
        paragraphs: [
          "BlueSkyIT có quyền thay đổi nội dung điều khoản sử dụng bất kỳ lúc nào mà không cần thông báo trước. Bạn có trách nhiệm thường xuyên kiểm tra để đảm bảo hiểu rõ và tuân theo điều khoản được đề cập đến trong phần này.",
        ],
      },
    ],
  },
};
